import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Group755 from "../../Images/Group755.png";
import Group839 from "../../Images/Group839.png";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  Avatar,
  
} from "@mui/material";
import bubble_bf  from "../../Images/bubble_bg.png";
import bg_image from "../../Images/JobPortal_bgImage.png";
import Socialmedia_img from "../../Images/Narajo_Landing_page_03.webp"
import Stack from "@mui/material/Stack";
import { axiosAPI } from "../Axios/Axios";
import { Chip, Container } from "@mui/material";
import CustomButton from "../Components/CustomButton";
import { useLocation, useNavigate } from "react-router-dom";
import InputBase from "@mui/material/InputBase";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import "./Style.css";
import {
  errorNotify,
  infoNotify,
  isValidEmail,
  succesNotify,
  warningNotify,
} from "../CommonCode/Commonfunc";

import { useSelector } from "react-redux";
import { profanityfn } from "../Profanity/Profanity";
import { styled } from '@mui/material/styles';
import Adswiper from "../Components/Swiper";

const CustomInput = styled(InputBase)(({ theme }) => ({
  ml: 1,
  flex: 1,
  color: "#47CCC2",
  fontStyle: "normal",
  fontWeight: 300,
  fontSize: "22px",
  lineHeight: "44px",
  '& .MuiInputBase-input::placeholder': {
    color: '#47CCC2', // Change this to your desired color
    opacity: 1, // Ensure the placeholder color is not transparent
  },
}));
const MainFeaturedPost = () => {
  const theme = useTheme();
  const redirect = useNavigate();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const Labels = useSelector((state) => state.allLabels.labels);
  const allList = useSelector((state) => state.allList.list);
  const location = useLocation();
  const postData = location.state;
  const { jobsearch, city, skills, category, type, industryID } = postData
    ? postData
    : {};

  // -----------------Search Jobs----------------------
  const ProfanityList = useSelector((state) => state.Profanity.wordlist);

  const [formdata, setformData] = useState({
    jobsearch: "",
    city: "",
    skills: "",
    category: "",
    type: "",
    industryID: "",
  });

  useEffect(() => {
    setformData({
      jobsearch: jobsearch ? jobsearch : "",
      city: city ? city : "",
      skills: skills ? skills : "",
      category: category ? category : "",
      type: type ? type : "",
      industryID: industryID ? industryID : "",
    });
  }, [postData]);

  const JobSerach = (e) => {
    const value = e.target.value;
    setformData({
      ...formdata,
      [e.target.name]: profanityfn(ProfanityList, value),
    });
  };
  const SearchJobs = (e) => {
    e.preventDefault();
    if (!formdata.jobsearch && !formdata.city) {
      infoNotify(Labels.jobTitleLocation);
    } else {
      const postData = {
        jobsearch: formdata.jobsearch ? formdata.jobsearch : "",
        city: formdata.city ? formdata.city : "",
        skills: skills ? skills : "",
        category: category ? category : "",
        type: type ? type : "",
        industryID: industryID ? industryID : "",
      };
      redirect("/jobSearchPrelogin", { state: postData });
    }
  };
  const searchByHotkeys = (e, data) => {
    e.preventDefault();
    const postData = {
      category: [data.id].toString(),
      jobsearch: jobsearch ? jobsearch : "",
      city: city ? city : "",
      skills: skills ? skills : "",
      type: type ? type : "",
      industryID: industryID ? industryID : "",
    };
    redirect("/jobSearchPrelogin", { state: postData });
  };

  const searchJobByMoreCategory = (e) => {
    e.preventDefault();
    const postData = {
      search: "",
      city: "",
      isCategoryMore: "true",
    };
    redirect("/jobSearchPrelogin", { state: postData });
  };

  return (
    <Paper
      sx={{
        position: "relative",
        color: "#074966",
        mb: 0,
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundColor: "#fff",
        borderRadius: 0,
        overflow: "hidden",
        marginTop: { xs: "55px", sm: "60px", md: "72px" },
      }}
    >
      <Container maxWidth="xl">
        <div className="display-flex zIndex narajoHeroGrid">
        <div className="landingPage narajoHeroCopy">
  <Typography
    variant="h3"
    className="narajoHeroTitle"
    color="inherit"
    gutterBottom
  >
    <Box component="span" className="narajoHeroTitleLine">
      Find Your Dream Job
    </Box>
    <br />
    <Box component="span" className="narajoHeroTitleLine">
      With Us
    </Box>
  </Typography>
  <Stack direction="column" sx={{ marginBottom: 2 }}>
    <Typography
      sx={{
        fontSize: {
          xs: "16px",
          lg: "20px",
        },
        fontWeight: 400,
        color: "#111",
        marginTop: 2,
        maxWidth: "590px",
      }}
    >
      {Labels?.Discoveropportunitieswithleading	}
    </Typography>
    <Stack direction="row" spacing={2} sx={{ marginTop: 2 }}>
      <Button
        variant="outlined"
        sx={{
          borderRadius: "12px",
          color: "#fff",
          border: "1px solid #006B9A",
          backgroundColor:"#006B9A",
          textTransform: "none",
          px: 3,
          py: 1.2,
          "&:hover": {
            border: "1px solid #005F8E",
            backgroundColor: "#005F8E",
          },
        }}
        onClick={() => redirect("/jobSearchPrelogin", { state: postData })}
      >
      {Labels?.Explorejobs}
      </Button>
      <Button
        variant="outlined"
        sx={{
          borderRadius: "12px",
          color: "#006B9A",
          border: "1px solid #006B9A",
          textTransform: "none",
          px: 3,
          py: 1.2,
          "&:hover": {
            border: "1px solid #006B9A",
            backgroundColor: "#E7F8FD",
          },
        }}
        onClick={() => redirect("/login")}
      >
       {Labels?.login	}
      </Button>
    </Stack>
  </Stack>
</div>


          <div className="landingImageWrap narajoHeroImage">
            <img src={Socialmedia_img} alt="Job seeker searching" className="landingPage-img1" />
          </div>
        </div>
        <Stack className="narajoHeroSearchWrap" sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
        <div className="inputField_Mainclass">
          <div className="inputField">
            <CustomInput
              sx={{
                ml: 2,
                flex: 1,
                color: "#76AFC9",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "16px",
                lineHeight: "44px",
              }}
              name="jobsearch"
              value={formdata.jobsearch}
              onChange={(e) => JobSerach(e)}
              placeholder="Enter Skills/ Roles"
              inputProps={{ "aria-label": "enter skills or roles" }}
            />
            <Divider sx={{ height: 28, m: 0.5, borderColor: "#9CC9DB" }} orientation="vertical" />
            <InputBase
              sx={{
                ml: 2,
                flex: 1,
                color:"#76AFC9",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "16px",
                lineHeight: "44px",
              }}
              placeholder="Select Experience"
              inputProps={{ "aria-label": "select experience" }}
            />
            <Typography sx={{ color: "#76AFC9", fontSize: "16px", pr: 2 }}>
              v
            </Typography>
            <Divider sx={{ height: 28, m: 0.5, borderColor: "#9CC9DB" }} orientation="vertical" />
            <InputBase
              sx={{
                ml: 2,
                flex: 1,
                color:"#76AFC9",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "16px",
                lineHeight: "44px",
              }}
              placeholder="Enter Location"
              name="city"
              value={formdata.city}
              onChange={(e) => JobSerach(e)}
              inputProps={{ "aria-label": "enter location" }}
            />
            <IconButton
              aria-label="search jobs"
              onClick={SearchJobs}
              sx={{ color: "#006B9A", px: 2 }}
            >
              <SearchIcon sx={{ fontSize: "34px" }} />
            </IconButton>
            </div>
          </div>
        </Stack>
        {/* <Stack sx={{ display: "none" }}>
        <div className="inputField_Mainclass">
          <div className="inputField">
   
            <IconButton
              sx={{
                pl: "24px",
                color: "#51DEA9",
              }}
              aria-label="menu"
            >
              <SearchIcon
                sx={{
                  fontSize: "40px",
                  color: "#51DEA9",
                }}
              />
            </IconButton>
            <CustomInput
              sx={{
                ml: 1,
                flex: 1,
                color: "#51DEA9",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "22px",
                lineHeight: "44px",
              }}
              name="jobsearch"
              value={formdata.jobsearch}
              onChange={(e) => JobSerach(e)}
              placeholder="Enter Skills/ Roles"
              inputProps={{ "aria-label": "search google maps" }}
            />
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <IconButton
              sx={{ pl: "10px", pt: "2px", color: "#2B4947" }}
              aria-label="menu"
            >
              <LocationOnOutlinedIcon
                sx={{
                  display: "none",
                }}
              />
            </IconButton>
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                color:"#76AFC9",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "16px",
                lineHeight: "44px",
              }}
              placeholder="Select Experience"
              inputProps={{ "aria-label": "select experience" }}
            />
            <Typography sx={{ color: "#76AFC9", fontSize: "20px", pr: 2 }}>
             ⌄
            </Typography>
            <Divider sx={{ height: 28, m: 0.5 }} orientation="vertical" />
            <InputBase
              sx={{
                ml: 1,
                flex: 1,
                color:"#47CCC2",
                fontStyle: "normal",
                fontWeight: 300,
                fontSize: "22px",
                lineHeight: "44px",
              }}
              placeholder="Enter Location"
              name="city"
              value={formdata.city}
              onChange={(e) => JobSerach(e)}
              inputProps={{ "aria-label": "search google maps" }}
            />
            <CustomButton
              label={Labels?.search}
              style={{
                width: 150,
                height: 50,
              
                fontSize: "23px",
              }}
              onClick={SearchJobs}
            />
            </div>
          </div>
        </Stack> */}
        {isMobile ? (
          <Box
            className="mobileSearchPanel"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              marginTop: { xs: "60px" },
            }}
          >
            <Paper
              sx={{
                pr: 4,
                display: "flex",
                alignItems: "center",
                height: 40,
                boxShadow: "0px 4px 35px rgba(0, 0, 0, 0.06)",
                borderRadius: "5px",
                width: "100%",
              }}
            >
              <IconButton
                sx={{
                  pl: "10px",
                  color: "#2B4947",
                }}
                aria-label="menu"
              >
                <SearchIcon
                  sx={{
                    fontSize: "28px",
                  }}
                />
              </IconButton>
              <InputBase
                sx={{
                  ml: 1,
                  flex: 1,
                  color: "#2B4947",
                  fontStyle: "normal",
                  fontWeight: 300,
                  fontSize: "20px",
                  lineHeight: "44px",
                }}
                name="jobsearch"
                value={formdata.jobsearch}
                onChange={(e) => JobSerach(e)}
                placeholder={Labels?.JobtitleorKeyword}
                inputProps={{ "aria-label": "search google maps" }}
              />
            </Paper>
            <Paper
              sx={{
                marginTop: 1,
                pr: 4,
                display: "flex",
                alignItems: "center",
                height: 40,
                boxShadow: "0px 4px 35px rgba(0, 0, 0, 0.06)",
                borderRadius: "5px",
                width: "100%",
              }}
            >
              <IconButton
                sx={{ pl: "10px", pt: "2px", color: "#2B4947" }}
                aria-label="menu"
              >
                <LocationOnOutlinedIcon
                  sx={{
                    fontSize: "28px",
                  }}
                />
              </IconButton>
              <InputBase
                sx={{
                  ml: 1,
                  flex: 1,

                  color: "#2B4947",
                  fontStyle: "normal",
                  fontWeight: 300,
                  fontSize: "20px",
                  lineHeight: "44px",
                }}
                placeholder={Labels?.location}
                name="city"
                value={formdata.city}
                onChange={(e) => JobSerach(e)}
                inputProps={{ "aria-label": "search google maps" }}
              />
            </Paper>
            <CustomButton
              label={Labels?.search}
              style={{
                fontSize: "18px",
                marginTop: 2,
                width: 120,
                height: 40,
                background: "white",
                color: "#2B4947",
                "&:hover": {
                  color: "white",
                },
              }}
              onClick={SearchJobs}
            />
          </Box>
        ) : null}
        {/* -------------------- Skills -------------------- */}
        <Box
          className="heroCategoryChips narajoHeroChips"
          sx={{
            pt: 3,
            pb: 10,
            display: {
              xs: "block",
              sm: "block",
              md: "block",
              lg: "block",
              xl: "flex",
            },
            justifyContent: "space-between",
            alignItems: "center",
            textAlign: "center",
            
          }}
        >
          {allList?.categories && allList?.categories.length > 8
            ? allList?.categories.slice(0, 7).map((val, index) => {
                return (
                  <Chip
                    variant="outlined"
                    label={val.categoryName}
                    key={index}
                    sx={{
                      mb: 1,
                      mr: 1,
                      color: "#006B9A",
                      height: 40,
                      fontWeight: 300,
                      fontSize: { xs: "14px", md: "18px" },
                      lineHeight: "30px",
                      fontStyle: "normal",
                      borderRadius: "10px",
                      border: "1px solid #5AA8CF",
                      minWidth: "165px",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#E7F8FD",
                      },
                    }}
                    onClick={(e) => searchByHotkeys(e, val)}
                  />
                );
              })
            : allList?.categories &&
              allList?.categories.map((val, index) => {
                return (
                  <Chip
                    variant="outlined"
                    label={val.categoryName}
                    key={index}
                    sx={{
                      mb: 1,
                      mr: 1,
                      color: "#006B9A",
                      height: 40,
                      fontWeight: 300,
                      fontSize: { xs: "14px", md: "18px" },
                      lineHeight: "30px",
                      fontStyle: "normal",
                      borderRadius: "10px",
                      border: "1px solid #5AA8CF",
                      minWidth: "165px",
                      cursor: "pointer",
                      "&:hover": {
                        backgroundColor: "#E7F8FD",
                      },
                    }}
                    onClick={(e) => searchByHotkeys(e, val)}
                  />
                );
              })}
          {allList?.categories && allList?.categories.length > 8 && (
            <Typography
              sx={{ fontSize: "18px", cursor: "pointer", mb: 1 }}
              onClick={(e) => searchJobByMoreCategory(e)}
            >
              +{allList?.categories.length - 7} {Labels?.More}
            </Typography>
          )}
        </Box>
      </Container>
      <Adswiper />
    </Paper>
  );
};

export default MainFeaturedPost;
